<h1 class="title" translate>HOMEPAGE.ESG.TITLE</h1>
<div class="under-title ic1-mb-12" translate>ESG.UNDER_TITLE</div>
<app-page-wrapper>
  <div class="card-container">
    <div class="desc" translate>ESG.MAIN_CARD.DESC</div>
    <div class="ic1-row max-width">
      <!-- GREEN CARDS -->
      <div class="ic1-col-12 ic1-col-lg-4 no-padding">
        <div class="card green ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/paper.svg" alt="" />
            <div class="number">
              {{ response.paper | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.SAVED_PAPERS</div>
        </div>
        <div class="card green ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/water.svg" alt="" />
            <div class="number">
              {{ response.water | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.SAVED_WATER_CUPS</div>
        </div>
        <div class="card green ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/cloud.svg" alt="" />
            <div class="number">
              {{ response.co2 | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.SAVED_CO2</div>
        </div>
      </div>
      <!-- GREY CARDS -->
      <div class="ic1-col-12 ic1-col-lg-4 no-padding">
        <div class="card grey ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/tree.svg" alt="" />
            <div class="number">
              {{ response.tree | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.SAVED_TREES</div>
        </div>
        <div class="card grey ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/shower.svg" alt="" />
            <div class="number">
              {{ response.shower | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.SAVED_SHOWERS</div>
        </div>
        <div class="card grey ic1-my-12">
          <div class="icon-number">
            <img src="assets/images/esg/tree.svg" alt="" />
            <div class="number">
              {{ response.treeCo2 | numberFormatPipe: '.' }}
            </div>
          </div>
          <div class="label" translate>ESG.MAIN_CARD.TREES_CO2</div>
        </div>
      </div>
      <!-- SIGN CARDS -->
      <div class="ic1-col-12 ic1-col-lg-4 no-padding">
        <div class="signs-container">
          <div class="card ic1-my-12">
            <span
              class="signs-text"
              [innerHTML]="'ESG.MAIN_CARD.GENERATED_SIGNS' | translate"
              translate-key="ESG.MAIN_CARD.GENERATED_SIGNS"></span>
          </div>
          <div class="card ic1-my-12">
            <b class="signs-text">
              {{ response.totalSIGN | numberFormatPipe: '.' }}
            </b>
            <div class="signs-text" translate>
              ESG.MAIN_CARD.SIGN_TRANSACTIONS
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-container innovation-card ic1-mt-16">
    <div class="title" translate>ESG.INNOVATION_CARD.TITLE</div>
    <div class="desc" translate>ESG.INNOVATION_CARD.DESC</div>
    <div class="button-container">
      <ng-ui-kit-button
        class="full-button"
        color="tertiary"
        [label]="'ESG.INNOVATION_CARD.BUTTON' | translate"
        [ariaLabel]="'ESG.INNOVATION_CARD.BUTTON_ARIA_LABEL' | translate"
        type="button"
        size="sm"
        (onClick)="openUrl()">
      </ng-ui-kit-button>
    </div>
  </div>
</app-page-wrapper>
